import { Injectable, inject } from '@angular/core';
import { ApiService } from '@services/api/api.service';
import { ApiResponse } from '@interfaces/response';
import {Observable} from 'rxjs';
import {User} from '@interfaces/user';
import {Login} from '@interfaces/login';

@Injectable({
  providedIn: 'root'
})
export class UserApiService {

  private api_service = inject(ApiService);

  private user_url: string = '/users/me';
  private user_change_password_url: string = '/users/change-password';

  constructor() {
  }

  updateImageUser(payload: { avatar: string }): Observable<any> {
    let url = `${this.user_url}`;
    return this.api_service.patch<Observable<any>>(url, payload);
  }

  updateUser(name: string, lastname:string, email:string, username: string, phone:string, prefix:string): Observable<ApiResponse<User>> {
    let url = `${this.user_url}`;
    const body = {
      "name": name,
      "lastname": lastname,
      "email": email,
      "username": username,
      "phone": phone,
      "prefix": prefix
    }
    return this.api_service.patch<ApiResponse<User>>(url, body);
  }

  changePassword(old_password: string, new_password:string, confirm_new_password:string): Observable<ApiResponse<Login>> {
    let url = `${this.user_change_password_url}`;
    const body = {
      "old_password": old_password,
      "new_password": new_password,
      "confirm_new_password": confirm_new_password
    }
    return this.api_service.post<ApiResponse<Login>>(url, body);
  }


}
